import React from 'react';

import * as CreditActions from '../CreditActions';
import * as ActionConstants from '../../../utils/ActionConstants';
import * as CreditConstants from '../CreditConstants';
import CustomInput from '../../../common/components/CustomInput';
import CustomSelect from '../../../common/components/CustomSelect';
import * as Strings from '../../../utils/strings';
import { serializeForm, isValid } from '../creditUtils';

export default class CreditApplicationStep4 extends React.Component {
    next(e) {
        e.preventDefault();

        const form = serializeForm(this.refs);
        if (isValid(this.refs)) {
            CreditActions.goTo(CreditConstants.CREDIT_STEP5, { ...form });
        }
    }
    back = e => {
        e.preventDefault();
        CreditActions.goTo(CreditConstants.CREDIT_STEP3, {});
    };
    render() {
        // Business Owner Name
        // Business Owner: Home Address
        // Business Owner: Home City
        // Have you ever declared bankruptcy? (Yes or No)
        // SIN
        // DOB

        // businessOwnerName
        // businessOwnerStreet
        // businessOwnerCity
        // bankruptcy: Boolean
        // sin: String
        // dob: String // Can’t you pass this in as a date?

        return (
            <div className="credit-application-step">
                <form onSubmit={this.next.bind(this)}>
                    <div className="form-container">
                        <div className="row">
                            <CustomInput
                                ref="businessOwnerName"
                                label="Business Owner Name"
                                placeholder={
                                    Strings.CREDIT_CONTACT_NAME_PLACEHOLDER
                                }
                                required
                            />
                            <CustomInput
                                ref="businessOwnerStreet"
                                label="Home Address"
                                placeholder={Strings.ADDRESS_PLACEHOLDER}
                                required
                            />
                        </div>
                        <div className="row">
                            <CustomInput
                                ref="businessOwnerCity"
                                label={Strings.CITY}
                                placeholder={Strings.CITY_PLACEHOLDER}
                                required
                            />
                            <CustomSelect
                                ref="bankruptcy"
                                label="Have you ever declared bankruptcy?"
                                options={[
                                    { id: 0, text: 'yes', value: true },
                                    { id: 1, text: 'no', value: false }
                                ]}
                                required
                            />
                        </div>

                        <div className="row">
                            <CustomInput
                                ref="sin"
                                label={Strings.CREDIT_SIN}
                                placeholder={Strings.CREDIT_SIN_PLACEHOLDER}
                                required
                            />
                            <CustomInput
                                ref="dob"
                                label="Date of Birth (YYYY/MM/DD)"
                                placeholder={Strings.CREDIT_DOB_PLACEHOLDER}
                                required
                            />
                        </div>
                    </div>
                    <button className="left back-button" onClick={this.back}>
                        Back
                    </button>
                    <button className="right green">
                        {' '}
                        {Strings.CREDIT_BTN_NEXT}
                    </button>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/credit/components/CreditApplicationStep4.jsx